import { ReactNode } from 'react';

import { DocumentReceiptEntity } from '../../../generated-api';
import { ResultPageDocument } from '../defs/types';
import ReceiptTable from './ReceiptTable';

export function expandReceiptTable(record: ResultPageDocument<DocumentReceiptEntity>): ReactNode {
  if (record.error) {
    return;
  }
  return <ReceiptTable receipt={record.latest_revision} />;
}
